/**
 * @param {function} handler - принимает коллбэк обработчик, который будет вызываться с аргументом ширины при измнении размера окна
 * @returns {function} возврщает объект с методом remove, коллбэк для снятия слушателя
 */
export default function useWindowWidth(handler) {
  handler(window.innerWidth)

  const cb = () => {
    handler(window.innerWidth)
  }

  window.addEventListener('resize', cb, { passive: true })

  return { remove: () => window.removeEventListener('resize', cb) }
}
